export default __webpack_public_path__ + "static/media/hokky-absensi2.3f808895.png";